<template>
    <div class="sliderInstagram">
        <div class="row" id="instafeed">
            
        </div>
    </div>
</template>

<script>
    import Slick from 'vue-slick'
    export default {
        components: {
            Slick
        },
        mounted() {

            var feed = new Instafeed({
                accessToken: process.env.TOKEN_INSTAGRAM,
                limit: 6,
                template: '<div class="col-6 col-md-3 col-lg-2 imagen"><a href="{{link}}" target="_blank"><img src="{{image}}" alt="Instagram image"></a></div>'
            });
            feed.run();
        },
    }
</script>

<style scoped>
    .row{
        align-items: center;
        background-color: #EC4802;
    }
    
</style>

<style>
    .sliderInstagram .imagen{
        padding: 0;
    }
    .sliderInstagram img{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/SliderInstagram.vue